/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { isNotNil } from 'es-toolkit';
import { type LDContext } from 'launchdarkly-react-client-sdk';

import { type IntegrationsContextQuery } from '@fai/friendli-suite/generated/client/graphql';

const userAnonymousContext: LDContext = { kind: 'user', anonymous: true };
const teamAnonymousContext: LDContext = { kind: 'team', anonymous: true };

export const parseLDContext = (d: IntegrationsContextQuery) => {
  const clientUser = d?.clientSession?.user;
  const clientTeam = d?.clientTeam;

  const context = {
    kind: 'multi',
    user: isNotNil(clientUser)
      ? {
          key: clientUser.id,
          name: clientUser.name,
          email: clientUser.email,
          superRoles: clientUser.superRoles?.roles,
        }
      : userAnonymousContext,
    team: isNotNil(clientTeam)
      ? {
          key: clientTeam.id,
          name: clientTeam.name,
          segment: clientTeam.segment,
          serverlessPlan: clientTeam.serverlessSubplan?.tier,
          dedicatedPlan: clientTeam.dedicatedSubplan?.tier,
          containerPlan: clientTeam.containerSubplan?.tier,
        }
      : teamAnonymousContext,
    // device: {
    //   key: ???, // NOTE: Using stored hash-string in local storage?
    //   name: userContextData?.clientSession?.userAgent?.device.model,
    //   os: userContextData?.clientSession?.userAgent?.os.family,
    // },
  };

  return context;
};
